import $ from 'jquery';
import Swal from 'sweetalert2';
import pRetry from 'p-retry';
import { protectRoute, commonMiddleware } from '../router/middleware';
import {
  initOnModalServiziEvents,
  hideSpinner,
  initScrollToTopArrow,
  initLoaderClickListeners,
  initOnModalCardsEvents,
} from './loader-utils';
import { renderLoader } from './renderLoader';
import { initPlayYouTubeModal } from '~src/help';
import { getUser } from '~src/user';
import { FEATURES, isFeatureEnabled } from '../features';

const shouldRefreshUser = (params) =>
  params && params.refreshUser && params.refreshUser === 'true';

const maybeRefreshUser = async (params = {}) => {
  if (!shouldRefreshUser(params)) {
    return;
  }

  Swal.fire({
    text: 'Stiamo aggiornando il tuo account...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  await pRetry(
    async () => {
      const response = await getUser({}, true);

      if (response.user.tipo_istanza === 'demo') {
        throw new Error('Org not updated yet');
      }

      return response;
    },
    {
      retries: 10,
      onFailedAttempt: (error) => {
        console.log(
          `Attempt ${error.attemptNumber} failed. There are ${error.retriesLeft} retries left.`
        );
      },
    }
  );

  Swal.hideLoading();
  Swal.fire({
    title: 'Fatto!',
    text: 'Adesso puoi utilizzare Giotto nel pieno delle sue funzionalità',
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
};

export const initializeLoaderExperience = async ({
  inModal = false,
  params,
} = {}) => {
  if (!inModal) {
    $('body').removeClass('home-create-modal-open sidebar-context-locked');
    $('#home-create-modal').removeClass('is-open').attr('aria-hidden', 'true');
    $('#route-loader').removeClass('home-create-modal__content');
    await maybeRefreshUser(params);
    await protectRoute();
    await commonMiddleware();
  }

  hideSpinner();

  if (!inModal) {
    $('.editor-route').hide();
    $('#route-loader').show();
  }

  if (!inModal) {
    initScrollToTopArrow();
  }

  const allowCreateCards = await isFeatureEnabled(FEATURES.CREATE_CARDS);

  if (allowCreateCards) {
    initOnModalCardsEvents();
  } else {
    initOnModalServiziEvents();
  }

  initPlayYouTubeModal();
  if (!inModal) {
    initLoaderClickListeners();
    await renderLoader({ includeRecentProjects: !inModal });
    return;
  }

  // TODO: finish new Create dialog logic in modal
  // For now, use the old loader logic also in modal context
  initLoaderClickListeners();
  await renderLoader({ includeRecentProjects: false });
};
